/* eslint-disable import/prefer-default-export */
export const createAction = (type, payload) => ({ type, payload });
